import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import Icons from '../../../src/components/icons';
import { HeartFillIcon } from '@primer/octicons-react';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`A scalable set of icons handcrafted with `}<HeartFillIcon mdxType="HeartFillIcon" />{` by GitHub`}</p>
    <Icons mdxType="Icons" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      